export enum ImportInvitationColumnLevel {
    Ignore = 0,
    InvitationOnly = 1,
    Contact = 2
}
